import React from 'react';
import PropTypes from 'prop-types';
import oms from 'npm-overlapping-marker-spiderfier/lib/oms.min';
import { MAP, MARKER } from 'react-google-maps/lib/constants';

class Spiderfy extends React.PureComponent {
  static contextTypes = {
    [MAP]: PropTypes.object,
  };

  constructor(props, context) {
    super(props, context);

    this.oms = new oms.OverlappingMarkerSpiderfier(this.context[MAP], {
      markersWontMove: true,
      markersWontHide: true,
      legWeight: 0,
    });

    this.markerNodeMounted = this.markerNodeMounted.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
  }

  markerNodeMounted(ref) {
    if (!ref) {
      return null;
    }

    const { onSpiderClick } = this.props;
    const marker = ref?.state[MARKER];

    if (!marker) {
      return null;
    }

    const { props: { params: { id, locationId } = {} } = {} } = ref ?? {};

    this.mounted && this.oms.addMarker(marker);

    window.google.maps.event.addListener(marker, 'spider_click', (e) => {
      if (onSpiderClick) {
        onSpiderClick(id, locationId);
      }
    });
  }

  render() {
    const { children } = this.props;

    return React.Children.map(children, (child) =>
      React.cloneElement(child, { ref: this.markerNodeMounted }),
    );
  }
}

export default Spiderfy;
